import { render } from "./FeaturesServices.vue?vue&type=template&id=050e45c8"
import script from "./FeaturesServices.vue?vue&type=script&lang=js"
export * from "./FeaturesServices.vue?vue&type=script&lang=js"

import "./FeaturesServices.vue?vue&type=style&index=0&id=050e45c8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__